import {formatDateTime} from 'common/dateUtils';
import i18n from 'i18n';
import React from 'react';

export const scheduleContent = (name: string, scheduledTimes: string[], label = 'Transaction') => {
   return `${i18n.t('{{label}} {{name}} saved', {name, label})}
   ${scheduledTimes.map((t) => i18n.t('\nNext scheduled at {{time}}', {time: formatDateTime(t)}))}
   `;
};

export const ScheduleContentElement = (name: string, scheduledTimes: string[]) => (
   <div>
      {i18n.t('Transaction {{name}} saved', {name})}
      {scheduledTimes.map((t) => (
         <div>{i18n.t('Next scheduled at {{time}}', {time: formatDateTime(t)})}</div>
      ))}
   </div>
);
